( function ( $ ) {

    // smooth-scroll / toggle modal on click of id href
    $( document ).on( 'click', 'a[href^="#"]', function ( e ) {
        const href = $(this).attr('href');
        if ( href == '#' ) {
            // bail if no ID
            return;
        }
        const $target = $( href );
        if ( $target.length ) {
            e.preventDefault();
            if ( $target.hasClass('modal') ) {
                $target.modal('toggle');
                return;
            }
            ThemeJS.Functions.scroll_to_element( $target, null, function () {
                $target.focus();
                if ( $target.is(":focus") ) {
                    return false;
                } else {
                    $target.attr('tabindex','-1');
                    $target.focus();
                }
            });
        }
    });

})( jQuery );